export enum RoleColor {
  ADMIN = "var(--spectrum-global-color-static-red-400)",
  POWER = "var(--spectrum-global-color-static-orange-400)",
  BASIC = "var(--spectrum-global-color-static-green-400)",
  PUBLIC = "var(--spectrum-global-color-static-blue-400)",
  BUILDER = "var(--spectrum-global-color-static-magenta-600)",
  DEFAULT_CUSTOM = "var(--spectrum-global-color-static-magenta-400)",
}
